// Display label for a mechanism step, e.g. "1,5 transannular hydride shift".
// distance / transannular come from mechanism_step and are only filled in for
// steps where they make sense (shifts, proton transfers, cyclizations), so the
// label is driven by the data rather than by a list of step types. The backend
// casts transannular to a number, so it arrives as 1 / 0 / null.

// Cyclizations (incl. "oxygen cyclization") and WM rearrangements are
// deliberately never shown as transannular, even if the flag is set in the database.
export function isTransannularIgnored(mechanismType) {
    if (typeof mechanismType !== "string") return false;
    const type = mechanismType.toLowerCase();
    return type.includes("cyclization") || type === "wm rearrangement";
}

function formatMechanismStep(mechanismType, distance, transannular) {
    if (!mechanismType) return mechanismType;
    const distancePrefix = distance !== null && distance !== undefined && distance !== "" ? `1,${distance} ` : "";
    const transannularPrefix = Number(transannular) === 1 && !isTransannularIgnored(mechanismType) ? "transannular " : "";
    return `${distancePrefix}${transannularPrefix}${mechanismType}`;
}

export default formatMechanismStep;
